import { ProductCardViewData } from '@services/MarppleShop/features/ProductList/type';
import { html, View } from 'rune-ts';
import {
  CardProductError,
  CardProductView,
} from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductView.ts';
import { noop } from '@fxts/core';
import { assertIsDefined } from '@services/MarppleShop/shared/util/assert.ts';
import { convertMaybeDateToISOString } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/convertMaybeDateToISOString.ts';
import { requestUpdateProductIsLikedOrLogin } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/requestUpdateProductIsLikedOrLogin.ts';
import {
  GlobalTimerManager,
  TimerSubscriptionManager,
  TimerTick,
} from '@services/MarppleShop/shared/util/timer';

type TTypeACardProductViewProps =
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    };

type TTypeBCardProductViewProps =
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

type TTypeCCardProductViewProps =
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    };

type TTypeDCardProductViewProps =
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    };

type TTypeECardProductViewProps =
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

type TTypeFCardProductViewProps =
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

type TTypeGCardProductViewProps =
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

export type TCardProductViewProps =
  | TTypeACardProductViewProps
  | TTypeBCardProductViewProps
  | TTypeCCardProductViewProps
  | TTypeDCardProductViewProps
  | TTypeECardProductViewProps
  | TTypeFCardProductViewProps
  | TTypeGCardProductViewProps;

export type TCardProductControllerOptions = {
  resize_width: number;
  is_lazy?: boolean;
  klass?: string;
};

export type TCardProductControllerProps = {
  card_product_view_props: TCardProductViewProps;
  product_card_view_data: ProductCardViewData;
  options: TCardProductControllerOptions;
};

export class CardProductControllerView extends View<TCardProductControllerProps> {
  private timerSubscriptionManager: TimerSubscriptionManager = new TimerSubscriptionManager(this);

  onTimerTick(event: TimerTick) {
    const currentTime = new Date(event.detail.timestamp).toISOString();

    const {
      card_product_view_props: { type, size },
    } = this.data;

    if (type === 'B' && (size === 'Small' || size === 'Xlarge')) {
      const cardProductView = this.subView(CardProductView);
      assertIsDefined(cardProductView, new CardProductError());
      cardProductView.setBadgeRealtimeCurrentTime(currentTime);
    }

    if (type === 'B' && (size === 'Medium' || size === 'Large')) {
      const cardProductView = this.subView(CardProductView);
      assertIsDefined(cardProductView, new CardProductError());
      cardProductView.setRealtimeCurrentTime(currentTime);
    }
  }

  destroy() {
    this.timerSubscriptionManager.unsubscribe();
  }

  private handleProductImageLikeClick = async () => {
    const nextIsLiked = !this.data.product_card_view_data.is_liked;
    try {
      await requestUpdateProductIsLikedOrLogin(
        nextIsLiked,
        this.data.product_card_view_data.user_id,
        this.data.product_card_view_data.stores_product_id,
      );

      this.data.product_card_view_data.is_liked = nextIsLiked;
      const cardProductView = this.subView(CardProductView);
      assertIsDefined(cardProductView, new CardProductError());
      cardProductView.setProductImageIsLiked(nextIsLiked);
    } catch {
      noop();
    }
  };

  protected override onRender() {
    const globalTimer = GlobalTimerManager.getInstance();
    globalTimer.start(1000);

    this.timerSubscriptionManager.subscribe();
  }

  protected override onUnmount() {
    this.destroy();
  }

  protected override template(props: TCardProductControllerProps) {
    const { product_card_view_data, card_product_view_props, options } = props;

    const product_image = {
      thumbnail_info: product_card_view_data.thumbnail_info,
      is_liked: product_card_view_data.is_liked,
      is_lazy: props.options?.is_lazy ?? false,
      resize_width: props.options.resize_width,
      domain_name: product_card_view_data.domain_name,
      id: product_card_view_data.id,
      name: product_card_view_data.name,
      store_name: product_card_view_data.store_name,
    };

    const shop = {
      domain_name: product_card_view_data.domain_name,
      store_name: product_card_view_data.store_name,
      profile_image_url: product_card_view_data.profile_image_url,
      watcher_count: product_card_view_data.watcher_count,
      is_partner: product_card_view_data.is_partner,
    };

    const product_title = {
      name: product_card_view_data.name,
      domain_name: product_card_view_data.domain_name,
      id: product_card_view_data.id,
    };

    const price = {
      price: product_card_view_data.price,
      price_en: product_card_view_data.price_en,
      price_jp: product_card_view_data.price_jp,
    };

    const review = {
      review_score: product_card_view_data.review_score,
      review_count: product_card_view_data.review_count,
    };

    const count_view = {
      watcher_count: product_card_view_data.watcher_count,
    };

    const realtime = {
      ordered_at: product_card_view_data.ordered_at
        ? convertMaybeDateToISOString(product_card_view_data.ordered_at)
        : product_card_view_data.ordered_at,
      currentTime: new Date().toISOString(),
    };

    const badge_main = {
      ranking: product_card_view_data.ranking,
      quantity: product_card_view_data.quantity,
      is_quantity_public: product_card_view_data.is_quantity_public,
      sell_end_at: product_card_view_data.sell_end_at
        ? convertMaybeDateToISOString(product_card_view_data.sell_end_at)
        : product_card_view_data.sell_end_at,
      currentTime: new Date().toISOString(),
      prev_total_sales_amount: product_card_view_data.prev_total_sales_amount ?? null,
      current_total_sales_amount: product_card_view_data.current_total_sales_amount ?? null,
      realtime_current_rank: product_card_view_data.realtime_current_rank ?? null,
      product_shipping_policy: product_card_view_data.product_shipping_policy,
      price: product_card_view_data.price,
      goods_type_id: product_card_view_data.goods_type_id,
      stockInfo: product_card_view_data.stockInfo,
    };

    const badge_sub = {
      sell_end_at: product_card_view_data.sell_end_at
        ? convertMaybeDateToISOString(product_card_view_data.sell_end_at)
        : product_card_view_data.sell_end_at,
      quantity: product_card_view_data.quantity,
      is_quantity_public: product_card_view_data.is_quantity_public,
      currentTime: new Date().toISOString(),
      prev_total_sales_amount: product_card_view_data.prev_total_sales_amount ?? null,
      current_total_sales_amount: product_card_view_data.current_total_sales_amount ?? null,
      realtime_current_rank: product_card_view_data.realtime_current_rank ?? null,
      product_shipping_policy: product_card_view_data.product_shipping_policy,
      price: product_card_view_data.price,
      goods_type_id: product_card_view_data.goods_type_id,
      stockInfo: product_card_view_data.stockInfo,
    };

    const getStateArgs = {
      is_user_adult_verified: product_card_view_data.is_user_adult_verified,
      adultMeta: product_card_view_data.adultMeta,
      stockInfo: product_card_view_data.stockInfo,
      currentTime: new Date().toISOString(),
      sell_end_at: product_card_view_data.sell_end_at
        ? convertMaybeDateToISOString(product_card_view_data.sell_end_at)
        : product_card_view_data.sell_end_at,
    };

    if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Horizontal'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Horizontal'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      const ordered_at = realtime.ordered_at;
      assertIsDefined(ordered_at, new CardProductError());

      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          count_view,
          badge_realtime: {
            ranking: product_card_view_data.ranking,
            ordered_at,
            currentTime: new Date().toISOString(),
          },
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      const ordered_at = realtime.ordered_at;
      assertIsDefined(ordered_at, new CardProductError());

      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          realtime: {
            ordered_at,
            currentTime: new Date().toISOString(),
          },
          count_view,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      const ordered_at = realtime.ordered_at;
      assertIsDefined(ordered_at, new CardProductError());

      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          realtime: {
            ordered_at,
            currentTime: new Date().toISOString(),
          },
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      const ordered_at = realtime.ordered_at;
      assertIsDefined(ordered_at, new CardProductError());

      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          badge_realtime: {
            ranking: product_card_view_data.ranking,
            ordered_at,
            currentTime: new Date().toISOString(),
          },
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'C' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'C' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'D' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'D' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          badge_main,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          badge_main,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          badge_main,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          badge_main,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          badge_main,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          review,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          review,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          review,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          shop,
          product_title,
          price,
          review,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          review,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          review,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          review,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          review,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      return html`<div ${options.klass ? html`class="${options.klass}"` : ''}>
        ${new CardProductView({
          ...card_product_view_props,
          state: CardProductView.getState(getStateArgs),
          product_image,
          product_title,
          price,
          review,
          count_view,
          badge_main,
          badge_sub,
          onProductImageLikeClick: this.handleProductImageLikeClick,
        })}
      </div>`;
    } else {
      throw new CardProductError();
    }
  }
}
